import { useEffect, useRef } from 'react';

const ACTIVITY = ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const;

/**
 * Calls `onIdle` after `minutes` with no keyboard, pointer or touch activity. The
 * server enforces the same limit; this just ends the session on screen promptly,
 * which matters on shared workstations.
 */
export function useIdle(minutes: number, onIdle: () => void): void {
  const callback = useRef(onIdle);
  useEffect(() => {
    callback.current = onIdle;
  }, [onIdle]);

  useEffect(() => {
    let timer = window.setTimeout(() => {
      callback.current();
    }, minutes * 60_000);
    const reset = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        callback.current();
      }, minutes * 60_000);
    };
    for (const event of ACTIVITY) window.addEventListener(event, reset, { passive: true });
    return () => {
      window.clearTimeout(timer);
      for (const event of ACTIVITY) window.removeEventListener(event, reset);
    };
  }, [minutes]);
}
